import lib from './lib';
import { update } from './config';
import { initAnalyticsSession } from './init';
import { enablePageAutoTracking } from './lib/page';
import analytics from './directives/analytics';

export default async function install(app, options = {}) {
  update({ ...options, $app: app });

  app.directive('analytics', analytics);
  app.config.globalProperties.$analytics = app.$analytics = lib;

  await initAnalyticsSession();
  enablePageAutoTracking();
}

export const event = lib.event;
export const page = lib.page;
